<div *ngIf="(trackWorkTime$ | async) && currentUser.allowMobileClockIn" class="widget-bar {{breakType}}-break"
	(click)="openPunchWidget()" [ngClass]="{'mobile-bar': isMobile}" [class.isPunched]="(punchedIn$ | async)">
	<div class="middle-bar {{breakType}}-break">
		<div class="total-time-block">
			<div>
				<mat-icon class="icon-clock">
					access_time
				</mat-icon>
			</div>
			<div class="total-block">
				<!-- <div style="margin-bottom: 1px; padding-right: 3px;">TOTAL: </div> -->
				<div class="time-div">{{totalTime}}</div>

			</div>
		</div>
		<div class="total-time-block">
			<div class="job-block">
				<div class="job-div" *ngIf="lastTimeCard && lastTimeCard.job">{{lastTimeCard?.job.name}}</div>
				<div class="job-div" *ngIf="breakType === 'WORK' && !(lastTimeCard && lastTimeCard.job)">No Job
				</div>
				<div class="job-div" *ngIf="breakType && breakType === 'UNPAID_BREAK'">Unpaid Break</div>
				<div class="job-div" *ngIf="breakType && breakType === 'PAID_BREAK'">Paid Break</div>
			</div>
		</div>
	</div>
</div>